import { Component, OnInit, OnDestroy, ElementRef }     from '@angular/core';
import { ActivatedRoute, Router }           from '@angular/router';
import { Response }                         from '@angular/http';
import { ToasterModule,
  ToasterService,
  ToasterConfig }                    from 'angular2-toaster/angular2-toaster';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DealersService } from '../../_services/dealers.service';
import { CustomersService } from '../../_services/customers.service';

import {Dealer} from '../../_models/dealer';

@Component({
  selector: 'app-customertyresearch',
  templateUrl: 'customertyresearch.component.html',
  styleUrls: ['customertyresearch.component.css'],
  providers: [DealersService, CustomersService]
})
export class CustomerTyreSearchComponent implements OnInit, OnDestroy {
  public sub: any;
  private isLoading: boolean = false;
  public showMain:boolean = false;
  public dealerId: string='';
  public dealer: Dealer= new Dealer();
  public user: any;
  private registration: string = '';
  public season: string = 'sommer';
  public searchError: string;
  public searchMessage: string;
  public sellerInitials: string;
  public sellerInitialsErrorMessage: string = '';
  public dealerCode: string = '';
  private showSellerInitials: boolean = true;
  private isDealerCodeVerified: boolean = false;
  public invalidDealerCodeMessage: string = '';

  private toasterService: ToasterService;

  constructor(
    private dealersService: DealersService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private elementRef : ElementRef,
    toasterService: ToasterService,
    private customersService: CustomersService) {
    this.toasterService = toasterService;
  }

  ngOnInit(){
    sessionStorage.removeItem('agree');
    sessionStorage.removeItem('sellerInitial');
    this.sub = this.route.params.subscribe(params => {
      this.dealerId = params['dealerId'];
      if (params['sellerInitials'] && params['sellerInitials'] == 'false') {
        this.showSellerInitials = false;
      }
      this.dealersService
        .get(this.dealerId)
        .subscribe(
          p =>  {
            this.dealer = p;

            this.user=p.employees[0];
          }
        );
      // this.getCars();
    });
    setInterval(function() {
      window.top.postMessage(document.body.scrollHeight, "*");
    }, 500);
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  formatRegistration(value) {
    if (value) {
      value = value.toUpperCase();
      value = value.replace(/ /g, '');
      if (value.match(/^[A-Z]{2}\d*$/)) {
        if (value.length > 4) {
          value = value.substr(0, 2) + ' ' + value.substr(2, 2) + ' ' + value.substr(4);
        }
        else {
          value = value.substr(0, 2) + ' ' + value.substr(2);
        }
      }
    }

    this.registration = value;
  }

  findCustomerByRegNr() {
    if (this.sellerInitials || this.isDealerCodeVerified) {
      sessionStorage.setItem('sellerInitial', this.sellerInitials);
    };
    this.customersService.findTyreCustomerByRegNumber(this.registration.replace(/\s/g, ""), this.dealerId).subscribe(
      (response) => {
        this.searchError = '';
        this.searchMessage = 'Bil ikke kendt.';
        const customer = response.json();
        var id = customer.mauticId;
        if (this.isDealerCodeVerified) {
          top.window.location.href = '/#/tyreinfo?id=' + id+ '&season=' + this.season + "&dealerId=" + this.dealerId + "&orderType=dealer";
        }
        else {
          top.window.location.href = '/#/tyreinfo?id=' + id+ '&season=' + this.season + "&dealerId=" + this.dealerId + "&orderType=customer";
        }
      },
      (error) => {
        this.searchMessage = '';
        this.searchError = 'Bil ikke kendt.';
      }
    );
  }
  validateDealerCode()
  {
      if(this.dealerCode != undefined && this.dealerCode == this.dealer.dealerCode)
      {      
          this.invalidDealerCodeMessage = '';
          this.isDealerCodeVerified = true;    
      }
      else{
          this.invalidDealerCodeMessage = "Entered Dealer code is invalid";
          this.isDealerCodeVerified = false;    
      }
  }
  isNullOrUndefinedOrEmpty(object) {
    if (object == null || object == undefined || object == '') {
        return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/customertyresearch/customertyresearch.component.ts